var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.id_calciatore
    ? _c("div", { staticClass: "calciatore-comparison" }, [
        _vm._v(
          "\n  " +
            _vm._s(_vm.nomeCalciatore) +
            " - \n  " +
            _vm._s(_vm.preNomeSquadra) +
            " (" +
            _vm._s(_vm.prePrezzo) +
            ") -\n  " +
            _vm._s(_vm.postNomeSquadra) +
            " (" +
            _vm._s(_vm.postPrezzo) +
            ")\n"
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }